import {ErrorWrapper, ResponseWrapper} from '@/core/service/util'
import {RoomBaseApiService} from '@/core/service/room.baseapi.service'
import {Http} from '@/core/service/http.init'

class RoomRecordService extends RoomBaseApiService {
  constructor() {
    super()
  }

  async roomRecordClient() {
    try {
      const chkLocalhost = (url) => {
        return url.startsWith('http://localhost')
          || url.startsWith('https://localhost');
      }

      let baseServerUrl = process.env.VUE_APP_API_URL;
      if(baseServerUrl){
        if(chkLocalhost(baseServerUrl)){
          if(chkLocalhost(location.origin)){
            baseServerUrl = '';
          }else{
            baseServerUrl = location.origin;
          }
        }
      }
      if(!baseServerUrl || !baseServerUrl.trim()){
        baseServerUrl = '';
      }

      const response = await this.request().post(
          `/api/v3/room/${this.getRoomId()}/record/client`,
          {
            baseServerUrl
          }
      )
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async roomRecordPcAppClient() {
    try {
      const response = await this.request().get(
          `/api/v3/room/${this.getRoomId()}/record/pcApp`
      )
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getRoomRecordFileList() {
    try {
      const response = await this.request().get(
          `/api/v3/room/${this.getRoomId()}/recordList`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getRoomRecordFileUrl(recordId) {
    try {
      const response = await this.request().get(
          `/api/v3/record/download/otp/${recordId}`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async deleteRecordFile(recordId) {
    try {
      const response = await this.request().get(
          `/api/v3/record/delete/${recordId}`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}

export const roomRecordService = new RoomRecordService()
